import AsyncBaseDownloadAssetsPresenterFactory from './AsyncBaseDownloadAssetsPresenterFactory';

export default class AsyncDownloadSharedProjectAssetsPresenterFactory
	extends AsyncBaseDownloadAssetsPresenterFactory {
	constructor( { shareRef } ) {
		super();
		this._shareRef = shareRef;
	}

	forDownloadAsset( {
		asset, withRoundNumber, lowRes, assetSystem, snackbarSystem, onFinish, unpreviewable
	} ) {
		const { projectID } = asset;
		const assetIDs = [ asset.id ];
		return this._forDownloadAssets( {
			action: () => assetSystem.downloadSharedProjectAssets( {
				projectID, assetIDs, withRoundNumber, lowRes, shareRef: this._shareRef, unpreviewable
			} ),
			onFinish,
			snackbarSystem
		} );
	}

	forDownloadAssets( {
		assets, folders, withRoundNumber, assetSystem, snackbarSystem, lowRes, onFinish, unpreviewable
	} ) {
		const projectID = assets?.[ 0 ]?.projectID || folders?.[ 0 ]?.projectID;
		const assetIDs = assets?.map( asset => asset.id ) || [];
		return this._forDownloadAssets( {
			action: () => assetSystem.downloadSharedProjectAssets( {
				projectID, assetIDs, withRoundNumber, lowRes, shareRef: this._shareRef, unpreviewable
			} ),
			onFinish,
			snackbarSystem
		} );
	}
}
